import { X } from '@phosphor-icons/react';
import { Modal as AntModal } from 'antd';
import { Modal, type ModalProps } from 'semantic-ui-react';
import type { ReactNode } from 'react';
import { COLOR } from '@styles/theme';

const confirmButtonStyle = {
  background: COLOR.black,
  borderColor: COLOR.black,
  color: COLOR.white,
};

interface ISkupremeModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  size?: ModalProps['size'];
}

export function SkupremeModal({
  open,
  title,
  onClose,
  children,
  size,
}: ISkupremeModalProps) {
  return (
    <Modal size={size} onClose={onClose} open={open}>
      <Modal.Content>
        <div className="d-flex justify-content-between">
          <h3>{title}</h3>
          <X size={20} className="cursor-pointer" onClick={onClose} />
        </div>
        <div className="mt-2">{children}</div>
      </Modal.Content>
    </Modal>
  );
}

interface IConfirmationPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  closeText?: string;
  confirmText?: string;
  title?: string;
  message?: string | ReactNode;
  loading?: boolean;
}

export function ConfirmationPopup({
  open,
  onClose,
  closeText = 'Cancel',
  confirmText = 'Confirm',
  title = 'Are you sure?',
  message = 'Message',
  onConfirm,
  loading = false,
}: IConfirmationPopupProps) {
  return (
    <AntModal
      title={title}
      open={open}
      centered
      width={400}
      onCancel={onClose}
      onOk={onConfirm}
      okText={confirmText}
      cancelText={closeText}
      confirmLoading={loading}
      cancelButtonProps={{ disabled: loading }}
      okButtonProps={{ style: confirmButtonStyle }}
      destroyOnHidden
    >
      {message}
    </AntModal>
  );
}
